import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import VueIziToast from 'vue-izitoast';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';


import 'video.js/dist/video-js.css';
import 'izitoast/dist/css/iziToast.min.css';

extend('required', { ...required, message: '{_field_} is required' });

Vue.config.productionTip = false;

Vue.use(Argon);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.use(VueIziToast, { position: 'bottomRight' });

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

